module.exports = __webpack_public_path__ + "img/SL-M-240-310.5a44a484.svg";